import clsx from "clsx";
import { motion } from "framer-motion";
import type { PropsWithChildren } from "react";

/** Full-viewport overlay when the board in-flow drawer container is absent. */
export function AgentChatOverlayShell({ children }: PropsWithChildren) {
	return (
		<motion.div
			key="agent-chat-drawer-overlay"
			className={clsx(
				"drawer fixed inset-y-0 right-0 z-(--illumi-z-index-right-drawer)",
				"border-l border-border-subtle bg-surface-default",
				"flex h-dvh min-h-0 flex-col overflow-hidden",
				"w-full max-w-md",
				"select-text",
			)}
			initial={{ x: "100%" }}
			animate={{ x: 0 }}
			exit={{ x: "100%" }}
			transition={{
				type: "spring",
				damping: 25,
				stiffness: 300,
			}}
		>
			{children}
		</motion.div>
	);
}
